"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Skeleton", {
    enumerable: true,
    get: function() {
        return Skeleton;
    }
});
var _react = require("@chakra-ui/react");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var $startColor = (0, _react.cssVar)("skeleton-start-color");
var $endColor = (0, _react.cssVar)("skeleton-end-color");
var Skeleton = {
    baseStyle: function(param) {
        var theme = param.theme;
        var _obj;
        return _obj = {}, _define_property(_obj, $startColor.variable, theme.colors["background-skeleton-start"]), _define_property(_obj, $endColor.variable, theme.colors["background-skeleton-end"]), _obj;
    }
};
